import { message } from 'antd';
import Router from 'next/router';
import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { ILogin } from 'src/interfaces';
import { authService, userService } from 'src/services';

import { updateCurrentUser } from '../user/userSlice';
import {
  login,
  loginSuccess,
  loginFail,
  logout,
  loginPerformer
} from './authSlice';

function* loginSaga(action: PayloadAction<ILogin>) {
  try {
    const payload = action.payload;
    const resp = (yield call([authService, 'login'], payload)).data;

    // Store token, update store and redirect to dashboard page
    yield call([authService, 'setToken'], resp.token, payload?.remember);
    const userResp = yield call([userService, 'me']);
    yield put(updateCurrentUser(userResp.data));
    yield put(loginSuccess(resp));

    if (payload.redirect) {
      Router.push(decodeURIComponent(payload.redirect));
      return;
    }

    if (!userResp?.data?.isPerformer) {
      Router.push((!userResp.data.email || !userResp.data.username) ? '/user/account' : '/home');
    }

    if (userResp?.data?.isPerformer) {
      (!userResp.data.email || !userResp.data.username)
        ? Router.push('/creator/account')
        : Router.push(
            { pathname: '/[profileId]', query: { profileId: userResp.data.username || userResp.data._id } },
            `/${userResp.data.username || userResp.data._id}`
          );
    }
  } catch (e) {
    const error = yield Promise.resolve(e);
    message.error(error?.message || 'Incorrect credentials!');
    yield put(loginFail(error));
  }
}

function* loginPerformerSaga(action: PayloadAction<any>) {
  try {
    const payload = action.payload;
    const { token } = payload;
    yield call([authService, 'setToken'], token);
    const userResp = yield call([userService, 'me']);
    yield put(updateCurrentUser(userResp.data));
    yield put(loginSuccess(payload));

    if (payload.redirect) {
      Router.push(decodeURIComponent(payload.redirect));
      return;
    }

    if (!userResp?.data?.isPerformer) {
      Router.push((!userResp.data.email || !userResp.data.username) ? '/user/account' : '/home');
    }

    if (userResp?.data?.isPerformer) {
      (!userResp.data.email || !userResp.data.username)
        ? Router.push('/creator/account')
        : Router.push(
            { pathname: '/[profileId]', query: { profileId: userResp.data.username || userResp.data._id } },
            `/${userResp.data.username || userResp.data._id}`
          );
    }
  } catch (e) {
    const error = yield Promise.resolve(e);
    message.error(error?.message || 'Incorrect credentials!');
    yield put(loginFail(error));
  }
}

function* logoutSaga() {
  yield call([authService, 'removeToken']);
  Router.replace({
    pathname: '/auth/login',
    href: '/'
  });
}

export default function* authSaga() {
  yield takeLatest(login.type, loginSaga);
  yield takeLatest(loginPerformer.type, loginPerformerSaga);
  yield takeLatest(logout.type, logoutSaga);
}